import type { FischerPlugin } from '@/lib/fischerPlugin';

const useMemoListFunction = (fischer: FischerPlugin) => fischer.shop.isClosedShop();

export { useMemoListFunction };
